import { makeStyles } from "@mui/styles";

export const useListContent = makeStyles({
    list: {
        padding: 0,
        height: "100%",
        width: "100%",
    },
});
